import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";
import { DownstreamreprocessModel } from "../../types/DownstreamreprocessModel";

const baseUrl = process.env.REACT_APP_API_URL;
const getAssetHistoryDetails=urlConfig.GetAssetHistoryDetail;

export const getAssetHistoryData = async (params: DownstreamreprocessModel) => {
  try {
    const response = await postCall(getAssetHistoryDetails, params);    
    return response.data;
  } catch (error) {
    console.error("Error in Asset History data fetching ", error);
    throw error;
  }
}